import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {FilterParams} from "../../models/filter_form.model";
import {ChartParams} from "../../views/chart/chart.component";
import { SitesService } from "../sites.service";
import { mergeFilterParams } from "../../lib/lib";
import { IStatResult, ITotal } from "../../models/responce_result.model";

const colors = {
	addThisShareBar: 'rgb(31, 119, 180)',//
	googleCounter: 'rgb(255, 127, 14)',//
	stages: 'rgb(44, 160, 44)',//
	timeline: 'rgb(214, 39, 40)',//
	uSocial: 'rgb(148, 103, 189)',//
	yandexCounter: 'rgb(140, 86, 75)',//
	audio: 'rgb(31, 119, 180)',//
	downloadFile: 'rgb(255, 127, 14)',//
	slideshare: 'rgb(44, 160, 44)',//
	video: 'rgb(214, 39, 40)',//
	backCall: 'rgb(31, 119, 180)',//
	contacts: 'rgb(255, 127, 14)',//
	feedBack: 'rgb(44, 160, 44)',//
	jivosite: 'rgb(214, 39, 40)',//
	liveChat: 'rgb(148, 103, 189)',//
	mailchimp: 'rgb(140, 86, 75)',//
	maps: 'rgb(227, 119, 194)',//
	bloquote: 'rgb(31, 119, 180)',//
	customHtml: 'rgb(255, 127, 14)',//
	goods: 'rgb(44, 160, 44)',//
	uCard: 'rgb(30, 129, 176)',//
	googlesearch: 'rgb(214, 39, 40)',//
	newsInformer: 'rgb(148, 103, 189)',//
	price: 'rgb(140, 86, 75)',//
	review: 'rgb(227, 119, 194)',//
	table: 'rgb(127, 127, 127)',//
	timer: 'rgb(188, 189, 34)',//
	ucalc: 'rgb(23, 190, 207)',//
	weather: 'rgb(31, 119, 180)',//
	yandexSearch: 'rgb(255, 127, 14)',//
	border: 'rgb(0, 255, 0)',//
	uSpacer: 'rgb(255, 127, 14)',//
	uButton: 'rgb(31, 119, 180)',//
	gallery: 'rgb(255, 127, 14)',//
	header: 'rgb(44, 160, 44)',//
	uIcon: 'rgb(214, 39, 40)',//
	imagezoom: 'rgb(148, 103, 189)',//
	uImage: 'rgb(52, 216, 200)',
	sliderWysiwyg: 'rgb(140, 86, 75)',//
	wysiwyg: 'rgb(227, 119, 194)',//
	ecwid: 'rgb(31, 119, 180)',//
	productCard: 'rgb(255, 127, 14)',//
	facebookLikeBox: 'rgb(31, 119, 180)',//
	instagram: 'rgb(255, 127, 14)',//
	odnoklassnikiLikeBox: 'rgb(44, 160, 44)',//
	pinterest: 'rgb(214, 39, 40)',//
	social: 'rgb(148, 103, 189)',//
	socialGroups: 'rgb(140, 86, 75)',//
	twitterLikeBox: 'rgb(227, 119, 194)',//
	uMenu: 'rgb(200, 200, 50)',
	uSeparator: 'rgb(133, 66, 99)',
	uSpoiler: 'rgb(12, 166, 200)',
};

interface IWidgetStats extends IStatResult, ITotal {}

@Component({
	selector: 'widget-report',
	templateUrl: './widget.component.html'
})
export class WidgetReportComponent extends BaseComponent {
	charts = [];
	stats = [];
	
	column: string = 'widgetAddCount';
	oldWidgets = ['icon', 'mainmenu', 'spacer', 'button', 'border'];
	
	widgetList = [];
	totalCount: number = 0;

	addFilterParams = {
		userType: 'user',
		isUserCharts : true,
		dateFilters : ['dateWidgetAdd', 'dateCreated', 'dateSiteCreated']
	};
	
	chartsCategory: string[] = [
		'main',
		'structure',
		'content',
		'shop',
		'media' ,
		'contacts',
		'social',
		'other'
	];
	
	chartLoader: boolean = false;
	listLoader: boolean = false;
	countLoader: boolean = false;

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public siteService: SitesService,
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);
	}
	
	
	async getData() {
		await this.getCharts();
		await this.getList();
	}
	
	
	async getCharts() {
		let me = this;
		
		me.charts = [];
	
		me.chartLoader = true;
		
		for(let chartCategory of me.chartsCategory) {
			const { charts } = await me.siteService.widget.chart(
				mergeFilterParams(
					me.filter.filterParams,
					<FilterParams>{ chartCategory, }
				)
			).toPromise();
			
			let chartData = new ChartParams(),
				labels    = charts.reduce(
					function(obj, line) {
						if (line[0] !== 'x' && ! obj[line[0]]) {
							obj[line[0]] = me.translate.__(`widgets.${line[0]}.name`);
							if (me.oldWidgets.includes(line[0].toString())) {
								obj[line[0]] += ' old';
							}
						}
						return obj;
					},
					{
						gallery2: me.translate.__A(`widget.names.gallery2`),
					}
				);

			chartData.name = chartCategory;
			chartData.data = charts;
			
			let options = {
				names  : labels,
				colors : colors,
				title  : me.translate.__A('site.widget.' + chartCategory)
			};
			
			chartData.setOptions(options);
			
			me.charts.push(chartData);
		}
		
		me.chartLoader = false;
	}
	
	
	async getList() {
		let me = this;

		me.countLoader = true;
		
		const { total, stats } = await me.siteService.widget.stats<IWidgetStats>(
			me.filter.filterParams
		).toPromise();
		me.totalCount = total;
		me.stats = stats;

		me.countLoader = false;
	}
}
